import { Pipe, PipeTransform } from '@angular/core';
import { parseTimeSpan } from '../DateTimeUtils';

@Pipe({ name: 'timeSpan' })
export class TimeSpanPipe implements PipeTransform {
  transform(value: string): string {
    return parseTimeSpan(value);
  }
}
